module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"columns":{}},"de":{"columns":{}}}')
  delete Component.options._Ctor
}
